import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { CuentaAutocompleteComponent } from '../../../components/common/autocomplete';
import { ColaboradorAutocompleteComponent } from '../../../components/common/autocomplete';
import { CategoriaAutocompleteComponent } from '../../../components/common/autocomplete';

@Component({
  selector: 'app-abmroles-filter',
  templateUrl: './abmroles-filter.component.html',
  styleUrls: ['./abmroles-filter.component.scss']
})
export class ABMRolesFilterComponent implements OnInit {

  @Output() onFiltersApplied = new EventEmitter();

  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChild(CuentaAutocompleteComponent) cuentaAutocompleteComponent;
  @ViewChild(CategoriaAutocompleteComponent) categoriaAutocompleteComponent;

  public showFilters = false;

  constructor() { }

  ngOnInit() {
  }

  onApply(e){
    // dont hide the filter window when clicking the apply button
    e.stopPropagation();
    this.onFiltersApplied.emit({
      cuentas: this.cuentaAutocompleteComponent.selectedCuentas,
      categorias: this.categoriaAutocompleteComponent.selectedCategorias,
      colaboradores: this.colaboradorAutocompleteComponent.selectedColaboradores
    });
  }

  cleanFilters(e) {
    this.onApply(e);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abmroles-filter/abmroles-filter.component.ts